import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/companies")({
  component: Outlet,
});
